import { WeeztixCard } from "@jesus-central-church/ui";
import { SbWeeztixEvent } from "@storyblok/types/287435740670216/storyblok-components";

export function WeeztixCardComponent({ blok }: { blok: SbWeeztixEvent }) {
  return <WeeztixCard shopUrl={blok.shopUrl.url} guid={blok.data_ot_guid} />;
}
